/**
 * @file SentBadge.js
 * @description Reusable badge component for notification sent types (Email, SMS, Push).
 */

import { getText } from '../../i18n';

const BADGE_VARIANTS = {
    email: {
        color: '#2F2B43',
        background: 'rgba(47, 43, 67, 0.2)',
        icon: 'bi-envelope',
        label: getText('msg_84add5b29527'),
    },
    sms: {
        color: '#14BA6D',
        background: 'rgba(20, 186, 109, 0.1)',
        icon: 'bi-chat-text',
        label: getText('msg_9e10d4517d5a'),
    },
    push: {
        color: '#667085',
        background: 'rgba(102, 112, 133, 0.1)',
        icon: 'bi-bell',
        label: getText('msg_8f7f57b519fc'),
    },
};

function SentBadge({ variant, count }) {
    if (count <= 0) {
        return null;
    }

    const config = BADGE_VARIANTS[variant];
    if (!config) {
        return null;
    }

    const label = count > 1 ? `${config.label} (${count})` : config.label;

    return (
        <span
            style={{
                display: 'inline-flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                padding: '2px 8px 2px 6px',
                gap: '6px',
                height: '22px',
                background: config.background,
                border: `0.5px solid ${config.color}`,
                borderRadius: '16px',
                fontFamily: 'Inter, sans-serif',
                fontWeight: 500,
                fontSize: '12px',
                lineHeight: '18px',
                color: config.color,
                whiteSpace: 'nowrap',
            }}
        >
            <i
                className={`bi ${config.icon}`}
                style={{
                    fontSize: '12px',
                    color: config.color,
                }}
            />
            {label}
        </span>
    );
}

export default SentBadge;
